import Vue from "vue";
import VueRouter from "vue-router";
import Vuetify from "@/plugins/vuetify";
import config from "@/config/sou.config.js";

Vue.use(VueRouter);

let routes = config.routes;

/* eslint-disable */
const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 };
	},
});
/* eslint-enable */

router.beforeEach((to, from, next) => {
	const nearestWithTitle = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.title);
	const nearestWithMeta = to.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);
	const previousNearestWithMeta = from.matched
		.slice()
		.reverse()
		.find((r) => r.meta && r.meta.metaTags);
	if (nearestWithTitle) {
		document.title =
		Vuetify.framework.lang.t(nearestWithTitle.meta.title) + " - " + process.env.VUE_APP_NAME;
	} else if (previousNearestWithMeta) {
		document.title =
		Vuetify.framework.lang.t(previousNearestWithMeta.meta.title) +
			" - " +
			process.env.VUE_APP_NAME;
	}
	Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
		(el) => el.parentNode.removeChild(el)
	);
	if (!nearestWithMeta) return next();
	nearestWithMeta.meta.metaTags
		.map((tagDef) => {
			const tag = document.createElement("meta");
			Object.keys(tagDef).forEach((key) => {
				tag.setAttribute(key, tagDef[key]);
			});
			tag.setAttribute("data-vue-router-controlled", "");
			return tag;
		})
		.forEach((tag) => document.head.appendChild(tag));

	next();
});

export default router;
